import React, { Component } from 'react';
import { connect } from 'react-redux';
import Alert from 'react-s-alert';
import 'react-virtualized/styles.css';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import './assets/css/s-alert-default.css';
import './assets/css/s-alert-css-effects/slide.css';
import './assets/css/style.css';
import './assets/css/mobile.css';
import './assets/css/button.css';
import './assets/css/payment.css';

import * as actions from './common/actions';
import AlertCustomTemplate from './common/components/AlertCustomTemplate';

class App extends Component {

    render() {
        const { children, is_waiting } = this.props;
        return (
            <div>
                { is_waiting
                    ? <div className="loader-wrapper">
                        <div className="load-content">
                            <div className="loading loading--double"></div>
                            <div className="text">Loading...</div>
                        </div>
                    </div>
                    : null
                }
                { children }
                <Alert 
                    stack={{ limit: 3 }} 
                    effect="slide"
                    contentTemplate={AlertCustomTemplate}/>
            </div>
        );
    }
}

module.exports = connect(
    (state, routeParams) => {
        const { is_waiting } = state.waiting;
        return {
            is_waiting
        }
    }, 
    {
        ...actions
    }
)(App);



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/